export const matches: { [a: string]: string } = {
  'coffee-black/method-chemex/taste-classic': 'buna-dimaa',
  'coffee-black/method-chemex/taste-curious': 'limu',
  'coffee-black/method-chemex/taste-adventurous': 'rungeto',
  'coffee-black/method-pour-over/taste-classic': 'buna-dimaa',
  'coffee-black/method-pour-over/taste-curious': 'sierra-nevada',
  'coffee-black/method-pour-over/taste-adventurous': 'yirgacheffe',
  'coffee-black/method-french-press/taste-classic': 'buna-dimaa',
  'coffee-black/method-french-press/taste-curious': 'sierra-nevada',
  'coffee-black/method-french-press/taste-adventurous': 'yirgacheffe',
  'coffee-black/method-aeropress/taste-classic': 'buna-dimaa',
  'coffee-black/method-aeropress/taste-curious': 'limu',
  'coffee-black/method-aeropress/taste-adventurous': 'yirgacheffe',
  'coffee-black/method-espresso-maker/taste-classic': 'yirga-santos-espresso',
  'coffee-black/method-espresso-maker/taste-curious': 'sidamo-espresso',
  'coffee-black/method-espresso-maker/taste-adventurous': 'cerrado',
  'coffee-black/method-espresso-machine/taste-classic': 'yirga-santos-espresso',
  'coffee-black/method-espresso-machine/taste-curious': 'sidamo-espresso',
  'coffee-black/method-espresso-machine/taste-adventurous': 'cerrado',
  'coffee-black/method-filter-coffee-machine/taste-classic': 'buna-dimaa',
  'coffee-black/method-filter-coffee-machine/taste-curious': 'sierra-nevada',
  'coffee-black/method-filter-coffee-machine/taste-adventurous': 'limu',
  'coffee-black/method-full-automatic-machine': 'tiga-terra',
  'coffee-with-milk/method-chemex/taste-classic': 'buna-dimaa',
  'coffee-with-milk/method-chemex/taste-curious': 'sierra-nevada',
  'coffee-with-milk/method-pour-over/taste-classic': 'toleyo',
  'coffee-with-milk/method-pour-over/taste-curious': 'limu',
  'coffee-with-milk/method-french-press/taste-classic': 'buna-dimaa',
  'coffee-with-milk/method-french-press/taste-curious': 'sierra-nevada',
  'coffee-with-milk/method-aeropress/taste-classic': 'toleyo',
  'coffee-with-milk/method-aeropress/taste-curious': 'sierra-nevada',
  'coffee-with-milk/method-espresso-maker/taste-classic': 'yirga-santos-espresso',
  'coffee-with-milk/method-espresso-maker/taste-curious': 'sidamo-espresso',
  'coffee-with-milk/method-espresso-machine/taste-classic': 'yirga-santos-espresso',
  'coffee-with-milk/method-espresso-machine/taste-curious': 'sidamo-espresso',
  'coffee-with-milk/method-filter-coffee-machine/taste-classic': 'toleyo',
  'coffee-with-milk/method-filter-coffee-machine/taste-curious': 'sierra-nevada',
  'coffee-with-milk/method-full-automatic-machine': 'tiga-terra',
  'coffee-with-milk-and-sugar/method-chemex': 'buna-dimaa',
  'coffee-with-milk-and-sugar/method-pour-over': 'toleyo',
  'coffee-with-milk-and-sugar/method-french-press': 'toleyo',
  'coffee-with-milk-and-sugar/method-aeropress': 'toleyo',
  'coffee-with-milk-and-sugar/method-espresso-maker': 'yirga-santos-espresso',
  'coffee-with-milk-and-sugar/method-espresso-machine': 'grano-gayo-espresso',
  'coffee-with-milk-and-sugar/method-filter-coffee-machine': 'buna-dimaa',
  'coffee-with-milk-and-sugar/method-full-automatic-machine': 'tiga-terra',
  'coffee-decaf/method-chemex': 'decaf-entkoffeiniert',
  'coffee-decaf/method-pour-over': 'decaf-entkoffeiniert',
  'coffee-decaf/method-french-press': 'decaf-entkoffeiniert',
  'coffee-decaf/method-aeropress': 'decaf-entkoffeiniert',
  'coffee-decaf/method-espresso-maker': 'decaf-espresso-entkoffeiniert',
  'coffee-decaf/method-espresso-machine': 'decaf-espresso-entkoffeiniert',
  'coffee-decaf/method-filter-coffee-machine': 'decaf-entkoffeiniert',
  'coffee-decaf/method-full-automatic-machine': 'decaf-espresso-entkoffeiniert',
}
